module.exports = __webpack_public_path__ + "img/quebecor-logo.e153b2f2.svg";